import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgBodySunscreenGlyph from './svgs/BodySunscreenGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var bodySunscreenGlyph = (props => useIcon(SvgBodySunscreenGlyph, SvgBodySunscreenGlyph, props));

export { bodySunscreenGlyph as default };
